import { clsx } from 'clsx'

import { Member } from '@tribeplatform/gql-client/types'
import { MemberAvatarProps } from '@tribeplatform/react-components/common/components'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { MemberAvatars } from '../MemberAvatars.js'

interface Props {
  hosts: Member[]
  className?: string
  highlighted?: boolean
  textClassName?: string
  avatarSize?: MemberAvatarProps['size']
}

export const EventHostInfo = ({
  className,
  highlighted,
  hosts,
  avatarSize = 'lg',
  textClassName,
}: Props) => {
  const { formatList } = useI18n()
  return (
    <div
      className={clsx(
        className,
        'min-w-0',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
      )}
    >
      <div className="flex items-center gap-x-2 truncate">
        <MemberAvatars
          members={hosts}
          avatarSize={avatarSize}
          visibleCount={2}
          plusTooltip={
            <T
              defaultMessage="{names} are hosting this event."
              id="Event.HostInfo.PlusTooltip"
              values={{
                names: formatList(hosts?.map(member => member.name)),
              }}
            />
          }
        />
        {hosts.length > 0 && (
          <Text
            className={clsx(
              'truncate text-content-subdued text-sm',
              textClassName,
            )}
          >
            <T
              defaultMessage="Organized by {names}"
              id="Event.HostInfo.OrganizedBy"
              values={{
                names: formatList(hosts?.map(member => member.name)),
              }}
            />
          </Text>
        )}
      </div>
    </div>
  )
}
